import { getType } from 'typesafe-actions';
import { createMiddleware } from 'redux-beacon';
import { ActionTypes } from '../actions/upload';
import { pageView } from '../actions/app';
import { uploadEndEvent, uploadStartEvent, pageViewEvent, clickstreamComponentViewEvent, clickstreamInteractionEvent } from './definitions';
import wtaAnalytics from './wtaAnalytics';
import { collectRioEvent } from '../actions/rio';
import { COMPONENT, ELEMENT, INTERACTION, ORIGINS } from './constants';
var wta = wtaAnalytics();
var handleDetachedRioEvent = function handleDetachedRioEvent(action, prevState, nextState) {
  var origin = action.payload;
  var meta = action.meta;
  switch (origin) {
    case ORIGINS.DEMO_LINK_CLICK:
      return clickstreamInteractionEvent({
        payload: {
          interactionType: INTERACTION.TYPES.CLICK,
          elementName: ELEMENT.NAMES.DEMO_LINK,
          elementType: ELEMENT.TYPES.LINK,
          elementText: meta.text
        }
      }, prevState, nextState);
    case ORIGINS.DEMO_LINK_VIEW:
      return clickstreamComponentViewEvent({
        payload: {
          componentName: COMPONENT.NAMES.DEMO_LINK,
          componentType: COMPONENT.TYPES.LINK
        },
        meta: meta
      }, prevState, nextState);
    case ORIGINS.DEMO_LINK_HOVER:
      return clickstreamComponentViewEvent({
        payload: {
          componentName: COMPONENT.NAMES.DEMO_LINK_TOOLTIP,
          componentType: COMPONENT.TYPES.COMPONENT
        },
        meta: meta
      }, prevState, nextState);
    default:
      return [];
  }
};
export var eventsMap = function eventsMap(action) {
  switch (action.type) {
    case ActionTypes.UPLOAD_START:
      {
        return uploadStartEvent;
      }
    case ActionTypes.UPLOAD_END:
      {
        return uploadEndEvent;
      }
    case getType(pageView):
      {
        return pageViewEvent;
      }
    case getType(collectRioEvent):
      {
        return handleDetachedRioEvent;
      }
    default:
      {
        return [];
      }
  }
};
export var wtaMiddleware = createMiddleware(eventsMap, wta);